import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';
import { GetJoinPayload, WorkerContractStatus } from './useJoin.types';

export const useGetJoinRequests: BaseHookRequest<WorkerContractStatus[], GetJoinPayload> =
  params => {
    const [{ getRequest }, state] = useApi<WorkerContractStatus[]>(params);
    const getJoinRequests: BaseRequest<GetJoinPayload> = () => {
      return getRequest('/admin/join/requests');
    };
    return [getJoinRequests, state];
  };

export const useAcceptJoin: BaseHookRequest<undefined, GetJoinPayload> = params => {
  const [{ postRequest }, state] = useApi<undefined>(params);
  const acceptJoin: BaseRequest<GetJoinPayload> = details => {
    return postRequest('/admin/join/accept', details?.variables);
  };
  return [acceptJoin, state];
};

export const useDeleteJoin: BaseHookRequest<undefined, GetJoinPayload> = params => {
  const [{ postRequest }, state] = useApi<undefined>(params);
  const acceptJoin: BaseRequest<GetJoinPayload> = details => {
    return postRequest('/admin/join/deleteForever', details?.variables);
  };
  return [acceptJoin, state];
};
